
const digest = '17fe5bfee16d3f38f59791642df98bd63b3f8679cf98f5eeee6eaf9e36e50ab0';
const classes = {"wrapper":"_wrapper_qbn6j_1","header":"_header_qbn6j_9","title":"_title_qbn6j_15","content":"_content_qbn6j_19"};
const css = `._wrapper_qbn6j_1 {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 1px solid #e4e4e4;
  padding: 24px;
  gap: 10px;
}
._wrapper_qbn6j_1 ._header_qbn6j_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
._wrapper_qbn6j_1 ._header_qbn6j_9 ._title_qbn6j_15 {
  font-weight: 500;
  font-size: 16px;
}
._wrapper_qbn6j_1 ._content_qbn6j_19 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  